import { render, staticRenderFns } from "./NotifyPopover.vue?vue&type=template&id=67de6582&scoped=true"
import script from "./NotifyPopover.vue?vue&type=script&lang=js"
export * from "./NotifyPopover.vue?vue&type=script&lang=js"
import style0 from "./NotifyPopover.vue?vue&type=style&index=0&id=67de6582&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de6582",
  null
  
)

export default component.exports